import { useMemo } from 'react';
import OrderProductItem from '../../../../../global/OrderProductItem';
import { getFilteredMembershipItems } from '../../../../../utils/membership';
import { useSubscription } from '../../../SubscriptionProvider';
import SubscriptionSelectionSummary from '../SubscriptionSelectionSummary';

import './SubscriptionSelectionStarterKit.scss';

const SubscriptionSelectionStarterKit = () => {
  const {
    orderItems,
    onOrderItemsChange,
    optionSelected,
  } = useSubscription();

  const offeredItems = useMemo(
    () => getFilteredMembershipItems(optionSelected),
    [optionSelected],
  );

  const orderItemsFiltered = useMemo(() => offeredItems.reduce((acc, item) => {
    acc[item.id] = orderItems[item.id] || 0;
    return acc;
  }, {}), [orderItems, offeredItems]);

  return (
    <div className="SubscriptionSelectionStarterKit">
      <div className="SubscriptionSelectionStarterKit__items">
        {offeredItems.map((item) => (
          <OrderProductItem
            key={item.id}
            {...item}
            value={orderItemsFiltered[item.id] || 0}
            onChange={onOrderItemsChange}
            allowNone
          />
        ))}
      </div>
      <SubscriptionSelectionSummary selectedItems={orderItemsFiltered} />
    </div>
  );
};

export default SubscriptionSelectionStarterKit;
